export const getTplLabel = (tpl) =>
  tpl?.general?.content?.title || tpl?.kp_content_type || "Unknown template";


